export enum EditViewType {
  NOTEBOOK = "notebook",
  GRAPH = "graph",
  APP = "app",
}

export const DEFAULT_VIEW: EditViewType = EditViewType.NOTEBOOK;
export const VIEW_SEPARATOR = ",";
